import { BlastworksClientEvent, ClientController } from "client-controller";
import { FowlEnterBaseGameState } from "state-machine/states/fowl-enter-base-game-state";

export class SocialEnterBaseGameState extends FowlEnterBaseGameState {
    /**
     * Unlock the top bar
     */
    public onEnter(cascadeSkip?: boolean): void {
        ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_COMPLETE);
        super.onEnter(cascadeSkip);
    }
}
